import type { FC } from 'react';
import React from 'react';
import styled, { css } from 'styled-components';

import Bubble from '@lt/components/components/Bubble';
import HintButton from '@lt/components/components/HintButton';

import type { IServiceLayout } from './types';

const ServiceLayout: FC<IServiceLayout> = ({
  className = '',
  title = '',
  children,
  isMobile = false,
  tooltipText = '',
}) => (
  <StyledServiceLayout className={className}>
    <StyledHeaderContainer>
      <StyledHeader $isMobile={isMobile}>
        <span>{title}&nbsp;</span>
        {tooltipText && !isMobile ? (
          <Bubble text={tooltipText}>
            <StyledHintButton />
          </Bubble>
        ) : null}
      </StyledHeader>
    </StyledHeaderContainer>
    <StyledBodyContainer>{children}</StyledBodyContainer>
  </StyledServiceLayout>
);

const StyledServiceLayout = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > * {
    width: 100% !important;
  }
  img {
    max-width: none;
  }
`;

const StyledHeader = styled.div<{ $isMobile?: boolean }>`
  display: flex;
  margin-left: 10px;
  margin-bottom: 16px;

  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;

  ${({ $isMobile }) =>
    $isMobile &&
    css`
      margin-bottom: 8px;
      font-size: 18px;
      line-height: 22px;
    `}
`;

const StyledHintButton = styled(HintButton)`
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-bottom: 1px;
`;

export default ServiceLayout;
